import React, { useState } from 'react';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import styles from './style.module.css';
import postSignInMobile from 'hooks/useSignInMobile';
import { SignInMobileFormContent } from 'services/content';
import { Spinner } from 'components';

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const SignInMobileFormSchema = Yup.object().shape({
  mobile: Yup.string().matches(phoneRegExp, 'Phone number is not valid'),
});

const SignInMobileForm = ({ callbackMobileNumber }) => {
  const valuesSignin = { mobile: '' };
  const [submitted, setSubmitted] = useState(false);
  const [mobileSignin, mobileSigninVerify] = postSignInMobile();

  const submitFormSignin = async (payload) => {
    const payloadObject = {
      phone_number: payload.mobile.replace('0', '+44'),
    };
    setSubmitted(true);
    await mobileSignin(payloadObject);
    callbackMobileNumber(payload.mobile);
  };

  return (
    <>
      {submitted ? (
        <Spinner />
      ) : (
        <Formik
          initialValues={valuesSignin}
          validationSchema={SignInMobileFormSchema}
          validateOnChange={false}
          validateOnBlur={false}
          onSubmit={(values) => submitFormSignin(values)}>
          {(props) => (
            <form className={styles.form} onSubmit={props.handleSubmit}>
              <label className={styles.inputLabel} htmlFor="mobile">
                {SignInMobileFormContent.signinLabel}
              </label>
              <ErrorMessage
                name="mobile"
                render={(msg) => <div className={`coop-c-form-error__text ${styles.errorText}`}>{msg}</div>}
              />
              <input
                maxLength="11"
                id="mobile"
                data-testid="mobile-input-field"
                type="text"
                onChange={(e) => {
                  const {value} = e.target;
                  e.target.value = value.trim();
                  props.handleChange(e)
                }}
                onBlur={props.handleBlur}
                value={props.values.mobile}
                className={`coop-form__input hp-form-input ${
                  props.errors.mobile && props.touched.mobile && 'coop-form__invalid'
                }`}
                name="mobile"
              />
              <button type="submit" className={`coop-btn coop-btn--secondary coop-c-hero__cta ${styles.submit}`}>
                {SignInMobileFormContent.signinButton}
              </button>
            </form>
          )}
        </Formik>
      )}
    </>
  );
};

export default SignInMobileForm;
